<template>
  <div class="row" v-if="findScore">
    <div class="col-md-2">
      <vs-card>
        <vue-apex-charts type="radialBar" height="280" :options="chartOptions" :series="supportTracker.series" />
        <vs-list>
          <vs-list-item title="Folio de consulta"
            :subtitle="scoreResults.data.api_response.folioConsulta"></vs-list-item>
          <vs-list-item title="Fecha de consulta" :subtitle="scoreResults.data.updated_at"></vs-list-item>
          <vs-list-item title="Nombre" :subtitle="fullname"></vs-list-item>
          <vs-list-item title="RFC" :subtitle="scoreResults.data.api_response.persona.RFC"></vs-list-item>
          <vs-list-item title="Fecha nacimiento"
            :subtitle="scoreResults.data.api_response.persona.fechaNacimiento"></vs-list-item>
          <vs-list-item title="Nacionalidad"
            :subtitle="scoreResults.data.api_response.persona.nacionalidad"></vs-list-item>
          <vs-list-item title="Numero de creditos"
            :subtitle="scoreResults.data.api_response.creditos.length.toString()"></vs-list-item>
          <vs-list-item title="Numero de consultas"
            :subtitle="scoreResults.data.api_response.consultas.length.toString()"></vs-list-item>
          <vs-list-item title="Razones">
          </vs-list-item>
          <div class="mt-3 flex">
            <score-reason-chip :reason="reason" :key="i"
              v-for="(reason, i) in scoreResults.data.api_response.scores[0].razones" />
          </div>
        </vs-list>
        <vs-button class="mt-2" @click="updateScore()">
          Recalcular score
        </vs-button>
      </vs-card>
    </div>
    <div class="col-md-10">
      <ci-credits-table ref="creditTableComponent" @creditsUpdated="creditsUpdated" :person="person"
        :credits="scoreResults.data.api_response.creditos" :rfc="scoreResults.data.rfc" />
      <ci-requests-table :requests="scoreResults.data.api_response.consultas" />
      <ci-addresses-table :addresses="scoreResults.data.api_response.domicilios" />
      <ci-jobs-table :jobs="scoreResults.data.api_response.empleos"></ci-jobs-table>
      <ci-messages-table :messages="scoreResults.data.api_response.mensajes" />
    </div>
  </div>
  <div v-else>
    <vs-card class="w-4/12">
      <div class="flex flex-col flex-gap-4">
        <vs-alert class="mb-4"> No hemos realizado una consulta de buro para esta persona</vs-alert>

        <vs-input label="RFC" v-model="rfc" />
        <vs-input class="mt-2" label="Primer nombre" v-model="person.first_name" />
        <vs-input class="mt-2" label="Segundo nombre" v-model="person.second_name" />
        <vs-input class="mt-2" label="Apellido Paterno" v-model="person.last_name_1" />
        <vs-input class="mt-2" label="Apellido Materno" v-model="person.last_name_2" />
        <vs-input class="mt-2" label="Colonia" v-model="person.address.neighborhood_model.name" />
        <vs-input class="mt-2" label="Calle" v-model="person.address.street" />

        <vs-button class="float-right mt-4" @click="getScore()">
          Consultar
        </vs-button>
      </div>
    </vs-card>
  </div>

</template>

<script>
import CiMessagesTable from "@components/credit-model/ci-score/ci-messages-table";
import CiAddressesTable from "@components/credit-model/ci-score/ci-addresses-table";
import CiCreditsTable from "@components/credit-model/ci-score/ci-credits-table";
import CiRequestsTable from "@components/credit-model/ci-score/ci-requests-table";
import VueApexCharts from "vue-apexcharts";
import { chartGaugeTemplate } from "@components/credit-model/ci-score/chartGaugeTemplate";
import { ApplicantService } from "@/services/ApplicantService";
import { ScoreService } from "@/services/score/ScoreService";
import CiJobsTable from "@components/credit-model/ci-score/ci-jobs-table";
import ScoreReasonChip from "@components/credit-model/ci-score/score-reason-chip";

export default {
  name: "PersonalProfileCdcModule",
  components: {
    ScoreReasonChip,
    CiJobsTable,
    CiMessagesTable,
    CiAddressesTable,
    CiCreditsTable,
    CiRequestsTable,
    VueApexCharts
  },
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  computed: {
    fullname() {
      let names = this.scoreResults.data.api_response.persona.nombres;
      let lastName1 = this.scoreResults.data.api_response.persona.apellidoPaterno;
      let lastName2 = this.scoreResults.data.api_response.persona.apellidoMaterno;
      return `${names} ${lastName1} ${lastName2}`
    },
    rfc() {
      if (this.isGenericRfc(this.person.rfc)) {
        return this.calculateRfc()
      }
      return this.person.rfc;
    }
  },
  data: () => ({
    scoreResults: {},
    findScore: false,
    ...chartGaugeTemplate
  }),
  async mounted() {
    this.$vs.loading();
    try {
      await this.main()
    } finally {
      this.$vs.loading.close();
    }
  },
  methods: {
    calculateRfc() {
      if (this.person.curp !== null) {
        return this.person.curp.substring(0, 10);
      }
      return '';
    },
    isGenericRfc(rfc) {
      return rfc === 'XAXX010101000';
    },
    selectAllCredits() {
      this.$refs.creditTableComponent.setAutomaticallyCredits();
      this.$refs.creditTableComponent.updateCredits();
    },
    async updateScore() {
      try {
        await this.getScore()
      } catch (e) {
        console.log(e)
      }
    },
    async setScore() {
      try {
        await ApplicantService.setScoreToPF(this.person.id, {
          score: this.scoreResults.data.api_response.scores[0].valor
        })
      } catch (e) {
        alert("Hubo un error al guardar el score del solicitante");
      }
    },
    async getScore() {
      this.$vs.loading();
      try {
        this.scoreResults = await ScoreService.request({
          personalProfileId: this.person.id,
          persona: {
            apellidoPaterno: this.person.last_name_1,
            apellidoMaterno: this.person.last_name_2,
            primerNombre: this.person.first_name,
            segundoNombre: this.person.second_name,
            fechaNacimiento: this.person.birth_date,
            rfc: this.rfc,
            nacionalidad: "MX"
          },
          domicilio: {
            direccion: this.person.address.street,
            coloniaPoblacion: this.person.address.neighborhood_model.name,
            delegacionMunicipio: this.person.address.municipality,
            ciudad: this.person.address.neighborhood_model.city.name,
            estado: this.person.address.neighborhood_model.city.state.cc_code,
            cp: this.person.address.neighborhood_model.zipcode
          }
        });
        this.supportTracker.series = [this.scoreResults.data.api_response.scores[0].valor]

        await this.setScore()
        this.selectAllCredits();
      } catch (e) {
        if (typeof e.response.data === 'object') {
          let response = e.response.data;
          swal("Notificación", Object.entries(response).map((item) => item[0]).join("\n"), "warning")
        }
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },
    creditsUpdated(data) {
      this.main();
    },
    async main() {
      try {
        this.scoreResults = await axios.get(`/api/credit-score/personal/${this.person.id}`)
        if (this.scoreResults.data.api_response) {
          this.findScore = true;
          this.supportTracker.series = [this.scoreResults.data.api_response.scores[0].valor]
        }
      } catch (e) {
        this.scoreResults.data = {};
      }
    }
  }
}
</script>

<style scoped></style>
